/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

//@module Tracker
define(
	'Tavano.TrackerExtension.TrackerExtension.View'
,	[
	'Tracker'
	,	'Backbone'
	,	'Backbone.CompositeView'
	,	'jQuery'
	,	'ApplicationSkeleton.Layout'
	,	'GoogleUniversalAnalytics'
	
	]
,	function (
		tracker
	,	Backbone
	,	BackboneCompositeView
	,	jQuery
	,   ApplicationSkeletonLayout
	,	GoogleUniversalAnalytics
	
	)
{
	_.extend(tracker.prototype, {
        trackRemoveFromCart: function (line, event)
        {
            return this.track('trackRemoveFromCart', line);
        }

	});

	// _.extend(ApplicationSkeletonLayout.prototype, {
	// 	showContent: _.wrap(ApplicationSkeletonLayout.prototype.showContent, function (fn, options) {
	// 		setTimeout(function() {
	// 			tracker.getInstance().trackPageview('/' + Backbone.history.fragment);
	// 		}, 1000);
			

	// 		var ret = fn.apply(this, _.toArray(arguments).slice(1));
	// 		return ret;
	// 	})
	
	// });

	
});
